import React, { Component } from "react";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

import "./assets/css/landing.css";
import Phone from "./assets/img/hero.png";
import Feature from "./assets/img/features.png";
import Logo from "./assets/img/logo-light.svg";

import Android from "./assets/img/d-app1.svg";
import Apple from "./assets/img/d-app2.svg";

import { Link } from "react-router-dom";

import brochurePDF from "./assets/brochure.pdf";

import "./assets/vendor/icofont/icofont.min.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./assets/vendor/venobox/venobox.css";
import "./assets/vendor/remixicon/remixicon.css";
import "./assets/vendor/owl.carousel/assets/owl.carousel.min.css";

export default class Privacy extends Component {
  render() {
    return (
      <body>
        {/* ======= Header ======= */}
        <header
          id="header"
          className="fixed-top d-flex align-items-center header-transparent"
        >
          <div className="container d-flex align-items-center">
            <div className="logo mr-auto">
              <h1 className="text-light">
                <Link href="/">
                  <img src={Logo} alt="Logo" />
                </Link>
              </h1>
              {/* Uncomment below if you prefer to use an image logo */}
              {/* <a href="/"><img src="assets/img/logo.png" alt="" className="img-fluid"/></a>*/}
            </div>

            <nav className="nav-menu d-none d-lg-block">
              <ul>
                <li>
                  <Link to="/register">Register</Link>
                </li>
                <li>
                  <Link to="/login">Login</Link>
                </li>
              </ul>
            </nav>
            {/* .nav-menu */}
          </div>
        </header>
        {/* End Header */}

        {/* ======= Hero Section ======= */}
        <section id="hero">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 pt-5 pt-lg-0 order-2 order-lg-1 d-flex align-items-center">
                <div data-aos="zoom-out">
                  <h1>
                    Enjoy Affordable Homes and Lands with <br />
                    <span>Super Convenient Payment Plans</span>
                  </h1>
                  {/* <h2>We are team of talanted designers making websites with Bootstrap</h2> */}
                  <div className="text-center text-lg-left">
                    <br />
                    <br />
                    <br />
                    <Link
                      to="register"
                      className="btn-get-started scrollto"
                      style={{ borderRadius: "3px" }}
                    >
                      Get Started
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-5 order-1 order-lg-2 hero-img"
                data-aos="zoom-out"
                data-aos-delay="300"
              >
                <img
                  src={Phone}
                  className="img-fluid animated landing-img"
                  alt=""
                />
              </div>
            </div>
          </div>
          <svg
            className="hero-waves"
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28 "
            preserveAspectRatio="none"
          >
            <defs>
              <path
                id="wave-path"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="wave1">
              <use href="#wave-path" x="50" y="3" fill="rgba(68,148,0, .1)" />
            </g>
            <g className="wave2">
              <use href="#wave-path" x="50" y="0" fill="rgba(68,148,0, .2)" />
            </g>
            <g className="wave3">
              <use href="#wave-path" x="50" y="9" fill="#fff" />
            </g>
          </svg>
        </section>
        {/* End Hero */}

        <main id="main">
          {/* ======= F.A.Q Section ======= */}
          <section id="faq" className="faq section-bg">
            <div className="container">
              <div className="mt-4 mb-4">
                <div className="row">
                  <div className="container">
                    <h4 className="title text-center">
                      <a href="">PRIVACY POLICY</a>
                    </h4>
                    <p className="description">
                      <br /><br />
                      This page is used to inform visitors regarding our
                      policies with the collection, use, and disclosure of
                      Personal Information if anyone decided to use our Service.
                      <br /><br />
                      If you choose to use our Service, then you agree to the
                      collection and use of information in relation to this
                      policy. The Personal Information that we collect is used
                      for providing and improving the Service. We will not use
                      or share your information with anyone except as described
                      in this Privacy Policy.
                      <br /><br />
                      The terms used in this Privacy Policy have the same
                      meanings as in our Terms and Conditions, which is
                      accessible at Evest unless otherwise defined in
                      this Privacy Policy. Information Collection and Use
                      <br /><br />
                      For a better experience, while using our Service, we may
                      require you to provide us with certain personally
                      identifiable information, including but not limited to
                      device and location information. The information that we
                      request will be retained by us and used as described in
                      this privacy policy.
                      <br /><br />
                      The app does use third party services that may collect
                      information used to identify you.
                      <br /><br />
                      Link to privacy policy of third party service providers
                      used by the app<br /><br />
                      <ul>
                        <li>Google Play Services</li>
                        <li>AdMob</li>
                        <li>Firebase Analytics</li>
                        <li>Firebase Cloud Messaging</li>
                        <li>Log Data</li>
                      </ul>
                      <br /><br />
                      We want to inform you that whenever you use our Service,
                      in a case of an error in the app we collect data and
                      information (through third party products) on your phone
                      called Log Data. This Log Data may include information
                      such as your device Internet Protocol (“IP”) address,
                      device name, operating system version, the configuration
                      of the app when utilizing our Service, the time and date
                      of your use of the Service, and other statistics. Cookies
                      <br /><br />
                      Cookies are files with a small amount of data that are
                      commonly used as anonymous unique identifiers. These are
                      sent to your browser from the websites that you visit and
                      are stored on your device's internal memory.
                      <br /><br />
                      This Service does not use these “cookies” explicitly.
                      However, the app may use third party code and libraries
                      that use “cookies” to collect information and improve
                      their services. You have the option to either accept or
                      refuse these cookies and know when a cookie is being sent
                      to your device. If you choose to refuse our cookies, you
                      may not be able to use some portions of this Service.
                      Service Providers
                      <br /><br />
                      We may employ third-party companies and individuals due to
                      the following reasons:
                      <ul>
                        <li>To facilitate our Service;</li>
                        <li>To provide the Service on our behalf;</li>
                        <li>To perform Service-related services; or</li>
                        <li>
                          To assist us in analyzing how our Service is used.
                        </li>
                      </ul>
                      <br /><br />
                      We want to inform users of this Service that these third
                      parties have access to your Personal Information. The
                      reason is to perform the tasks assigned to them on our
                      behalf. However, they are obligated not to disclose or use
                      the information for any other purpose. Security
                      <br /><br />
                      We value your trust in providing us your Personal
                      Information, thus we are striving to use commercially
                      acceptable means of protecting it. But remember that no
                      method of transmission over the internet, or method of
                      electronic storage is 100% secure and reliable, and we
                      cannot guarantee its absolute security. Links to Other
                      Sites
                      <br /><br />
                      This Service may contain links to other sites. If you
                      click on a third-party link, you will be directed to that
                      site. Note that these external sites are not operated by
                      us. Therefore, we strongly advise you to review the
                      Privacy Policy of these websites. We have no control over
                      and assume no responsibility for the content, privacy
                      policies, or practices of any third-party sites or
                      services. Children’s Privacy
                      <br /><br />
                      These Services do not address anyone under the age of 18.
                      We do not knowingly collect personally identifiable
                      information from children under 18. In the case we
                      discover that a child under 18 has provided us with
                      personal information, we immediately delete this from our
                      servers. If you are a parent or guardian and you are aware
                      that your child has provided us with personal information,
                      please contact us so that we will be able to do necessary
                      actions. Changes to This Privacy Policy
                      <br /><br />
                      We may update our Privacy Policy from time to time. Thus,
                      you are advised to review this page periodically for any
                      changes. We will notify you of any changes by posting the
                      new Privacy Policy on this page. These changes are
                      effective immediately after they are posted on this page.
                      Contact Us
                      <br /><br />
                      If you have any questions or suggestions about our Privacy
                      Policy, do not hesitate to contact us.
                      <br /><br />
                      Our contact email address is admin@ssafrihomes.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-4 mb-4">
              <br />
              <br />
              <h3 className="container">
                Download The App On Google Play Store or The Apple Store
              </h3>
              <br />
              <br />
              <div className="uk-margin-left mob-align-center">
                <a
                  className="btn btn-primary mr-4"
                  href="https://play.google.com/store/apps/details?id=com.hipheckt.evestng"
                >
                  <img className="btn-img" src={Android} alt="" />
                </a>
                <a
                  className="btn btn-primary mr-4"
                  href="https://apps.apple.com/us/app/"
                >
                  <img className="btn-img" src={Apple} alt="" />
                </a>
              </div>
            </div>
          </section>
          {/* End F.A.Q Section */}
        </main>
        {/* End #main */}

        {/* ======= Footer ======= */}
        <footer id="footer">
          <div className="container">
            <div className="copyright">
              &copy; Copyright{" "}
              <strong>
                <span>SS Afri Homes & Property Ltd.</span>
              </strong>{" "}
              All Rights Reserved
            </div>
            <div className="credits">
              1, Oyinlola Street, Behind Sweet Sensations, Sobo Bus Stop,
              Egbeda, Akowonjo Road, Lagos
            </div>
            <div className="credits">
              Codes by <a href="https://hipheckts.github.io">Hipheckts' Inc.</a>
            </div>
          </div>
        </footer>
        {/* End Footer */}

        <a href="#" className="back-to-top">
          <i className="icofont-simple-up"></i>
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=+2348027801044"
          class="floatbutton animated"
        >
          <i class="fa fa-whatsapp"></i>
        </a>
        {/* <div id="preloader"></div> */}

        {/* Template Main JS File */}
        <script src="assets/js/main.js"></script>
      </body>
    );
  }
}
